import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=235122d8&scoped=true&"
import script from "./BaseLoading.vue?vue&type=script&lang=js&"
export * from "./BaseLoading.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=235122d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235122d8",
  null
  
)

export default component.exports